import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/styles/lc.css';
import App from '@/App';

// The originating window owns popup and silent SSO responses. Mounting the
// application here would let its callback route navigate away and clear the hash
// before that window can read it. Full-page redirects still mount normally.
const isChildAuthCallback = window.location.pathname === '/auth/callback'
  && (window.opener !== null || window.parent !== window);

if (!isChildAuthCallback) {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
